import React from "react";
import PropTypes from "prop-types";

import Isvg from "../../../vendor/react-inlinesvg";

class FindField extends React.Component {
  constructor(props) {
    super(props);
    this.findFieldRef = React.createRef();

    this._onClearClick = this._onClearClick.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onKeyUp = this._onKeyUp.bind(this);
    this._submitForm = this._submitForm.bind(this);
  }

  _onClearClick(e) {
    e.preventDefault();
    this.props.onChange("");
  }

  _onChange(e) {
    const findValue = $(e.currentTarget).val();
    this.props.onChange(findValue);
  }

  _onKeyUp(e) {
    e.stopPropagation();
  }

  _submitForm(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.focusOnSubmit) {
      $(this.props.focusOnSubmit).focus();
    }
  }

  renderClearButton() {
    if (this.props.value.trim()) {
      return (
        <button
          type="button"
          onClick={this._onClearClick}
          onTouchEnd={this._onClearClick}
          className="clear-button"
        >
          <Isvg src="/img/x_gray.svg" />
          <span className="label">{i18n.t("input.clear")}</span>
        </button>
      );
    }
  }

  render() {
    return (
      <div className="find-field">
        <form onSubmit={this._submitForm}>
          <label htmlFor={"find-input-field-" + this.props.placeholder}>
            {i18n.t("input.find-results-update", {
              placeholder: this.props.placeholder
            })}
          </label>

          <input
            ref={this.findFieldRef}
            className="find input-search"
            type="search"
            id={"find-input-field-" + this.props.placeholder}
            placeholder={this.props.placeholder}
            value={this.props.value}
            onChange={this._onChange}
            onKeyUp={this._onKeyUp}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
          />
          {this.renderClearButton()}
        </form>
      </div>
    );
  }
}

FindField.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  focusOnSubmit: PropTypes.string,
  onChange: PropTypes.func
};

FindField.defaultProps = {
  value: "",
  placeholder: ""
};

module.exports = FindField;
